import React from 'react';
import styles from './Fieldset.module.scss';

const Fieldset = ({ legend, children, legendProps }) => {
  return (
    <fieldset className={styles.root}>
      {legend ? <legend {...legendProps}>{legend}</legend> : null}
      {children}
    </fieldset>
  );
};

export default Fieldset;
